(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.services')
		.service('NotifyService', NotifyService)

	/** @ngInject */
	function NotifyService(sweetAlert) {
		const NotifyService = {
			notify,
			success,
			error,
			warning
		};

		return NotifyService;

		function notify(config, callback, errCallback) {
			sweetAlert.swal(config).then(callback).catch(errCallback);
		}

		function success(title = 'SUCESSO!', message) {
			notify({
				title: title,
				type: 'success',
				text: message,
				confirmButtonClass: "btn btn-purple",
				cancelButtonClass: "btn btn-secondary",
			});
		}

		function error(title = 'ERRO!', message) {
			notify({
				title: title,
				type: 'error',
				text: message,
				confirmButtonClass: "btn btn-purple",
				cancelButtonClass: "btn btn-secondary",
			});
		}

		function warning(title = 'ATENÇÃO!', message) {
			notify({
				title: title,
				type: 'warning',
				text: message,
				confirmButtonClass: "btn btn-purple",
				cancelButtonClass: "btn btn-secondary",
			});
		}
	}
}());